import styled from "styled-components";

export const CommentCard = styled.div`
  position: relative;
  max-width: 350px;
  background: #fff;
  border-radius: 12px;
  text-align: center;
  overflow: hidden;
  padding-top: 56px;
  margin: auto;
  height: 320px;
`;

export const Avatar = styled.div`
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #181a1d;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const CommentText = styled.p`
  font-size: 16px;
  line-height: 26px;
  color: #000;
  padding: 32px 20px 24px;
`;

export const CommentFooter = styled.div`
  background: #181a1d;
  padding: 20px;
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
`;

export const AuthorName = styled.div`
  font-weight: 700;
  font-size: 16px;
  color: #fff;
`;

export const AuthorCompany = styled.div`
  font-size: 14px;
  color: #cfcfcf;
  margin-top: 4px;
`;
